import { IBuilding } from '@relab/alstom-ptw-shared';

import { ActionType, AppActionTypes } from '../types';

export function buildingsAction(): AppActionTypes {
  return {
    type: ActionType.BUILDINGS,
    payload: {
      request: {
        url: '/buildings',
        method: 'get',
      },
    },
  };
}

export function buildingUpsertAction(params: IBuilding): AppActionTypes {
  return {
    type: ActionType.BUILDING_UPSERT,
    payload: {
      building: {
        ...params,
      },
    },
  };
}

export function buildingDeleteAction(buildingId: string): AppActionTypes {
  return {
    type: ActionType.BUILDING_DELETE,
    payload: {
      request: {
        url: `/building/${buildingId}`,
        method: 'delete',
      },
      buildingId,
    },
  };
}
